import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {StandingsWidgetState} from "../models/standings-widget.state";
import {StandingsWidgetController} from "../standings-widget.controller";
import {STANDINGS_WIDGET} from "../standings-widget.consts";
import {ACTION_TYPES, COMPONENT_STATES} from "../../../core/consts";


export class StandingsWidgetChangeSeasonKeyHandler extends ActionHandler {
  controller: StandingsWidgetController;
  state: StandingsWidgetState;
  type = STANDINGS_WIDGET.ACTION_TYPES.onSeasonChange;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    if(this.state.selectedSeasonNum !== params.seasonNum) {
      this.store.setComponentState(COMPONENT_STATES.loading);
      this.state.selectedSeasonNum = params.seasonNum;

      await this.controller.action(ACTION_TYPES.fetch, {isPartialFetch: true});
      await this.controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeType, {index: null, disableFetch: false});

      this.store.setComponentState(COMPONENT_STATES.loaded);
      return params;
    }
  }
}
